import { render, staticRenderFns } from "./SongList2.vue?vue&type=template&id=7081ea9d"
import script from "./SongList2.vue?vue&type=script&lang=js"
export * from "./SongList2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports